import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitMaintenanceProtocolPage } from '@/loaders/unit.maintenance.protocol.loader';
import { SingelServiceProtocolPage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/maintenance/$protocolKey/')({
  component: SingelServiceProtocolPage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitMaintenanceProtocolPage,
});
